import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import { NavigationLink } from '../components';

import { ThemeImages, ThemeColors } from '../theme';
import oevs_logo from '../../images/customerexpert/logo_oevs.png';

class AccountActivated extends Component {
  get brandSettings() {
    if (window.location.search && window.location.search.includes('oevs')) {
      return {
        color: '#009EE3',
        logo: oevs_logo,
        name: 'ÖVS Star',
        signupRoute: 'signup-oevs',
        loginRoute: 'login-oevs',
        forgotPassswordRoute: 'forgotpassword-oevs',
        impressUrl: 'https://www.oevs-star.at/wp-content/uploads/2022/01/AGB_OeVS-Star.pdf',
      };
    }

    return {};
  }

  render() {
    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      marginTop: 'calc(50vh - 215px)',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75)',
    };
    const formGroupStyle = {
      width: '100%',
      textAlign: 'center',
    };
    return (

      <div style={containerStyle}>
        <div style={{ padding: 20 }}>
          <img src={this.brandSettings.logo || ThemeImages.logoPath} alt="Logo" style={{ width: '100%' }} />
        </div>
        <AppBar title="Account aktiviert"
          titleStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white', fontSize: 14 }}
          backgroundColor={this.brandSettings.color}
          showMenuIconButton={false} style={{ textAlign: 'center' }} />
        <div
          style={{
            ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
          }}
        >
          <span> Ihr Account wurde erfolgreich aktiviert.</span>
          <br />
          <span> Sie können sich jetzt anmelden.</span>
          <br /><br />
          <NavigationLink to={this.brandSettings.loginRoute || "login"}>Jetzt einloggen</NavigationLink>
        </div>
      </div>
    );
  }
}


export default AccountActivated;



// WEBPACK FOOTER //
// ./src/app/activateaccount/accountactivated.js